import { entityAPI } from "api/GenericAPI";
import { apiClient } from "api/APIClient";

import { Person, UnifiedInteractionLog } from "./CommunityInterfaces";


// ================== Generic API ==================
const basePeopleAPI = entityAPI<Person>("community", "people");

export const peopleAPI = {
  ...basePeopleAPI,

  getAllWithInteractionToken: async (
    interaction_token: string
  ): Promise<Person[]> => {
    return basePeopleAPI.getAll({ token: interaction_token });
  },

  getByIdWithInteractionToken: async (
    id: number,
    interaction_token: string
  ): Promise<Person> => {
    return basePeopleAPI.getById(id, { token: interaction_token });
  },

  createWithInteractionToken: async (
    payload: Partial<Person>,
    interaction_token: string
  ): Promise<Person> => {
    return basePeopleAPI.create(payload, { token: interaction_token });
  },

  updateWithInteractionToken: async (
    id: number,
    payload: Partial<Person>,
    interaction_token: string
  ): Promise<Person> => {
    return basePeopleAPI.update(id, payload, { token: interaction_token });
  },

  updateFieldWithInteractionToken: async (
    id: number,
    field: string,
    value: any,
    interaction_token: string
  ): Promise<Person> => {
    return basePeopleAPI.updateField(id, field, value, {
      token: interaction_token,
    });
  },

  deleteWithInteractionToken: async (
    id: number,
    interaction_token: string
  ): Promise<void> => {
    return basePeopleAPI.delete(id, { token: interaction_token });
  },
};


export const religionsAPI = entityAPI("community", "religion");

// ================== Custom Non-Standard API ==================
export const importPeopleFile = async (
  formData: FormData,
  action: "validate" | "resolve_addresses" | "import" = "import"
) => {
  const { data } = await apiClient.post(
    `/community/people/all/?action=${action}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      transformRequest: [(data) => data], // prevents JSON serialization
    }
  );

  return data;
};



export const getAllInteractionLogsByPerson = async (
  peopleId: number
): Promise<UnifiedInteractionLog[]> => {
  const { data } = await apiClient.get<UnifiedInteractionLog[]>(
    `/interactions/people/${peopleId}/logs/all/`
  );
  return data;
};